import React, { useCallback, useLayoutEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AllianceCard from "../../components/Cards/AllianceCard";
import "./css/index.css";
import { officeApi } from "../../api/config";
import UseCommonCard from "../../hooks/UseCommonCard";
import Emty from "../../components/Emty/Emty";
export interface AllianceDataType {
  prtn_apply_expired_fg: boolean;
  prtn_apply_st_at: string;
  prtn_desc: string;
  prtn_id: string;
  prtn_info: string;
  prtn_nm: string;
  prtn_sort_no: number;
  prtn_use: string;
  thumbnail: string;
}

/**팀플러 제휴 관리 */
function Alliance() {
  const navigate = useNavigate();
  const [AllianceData, setAllianceData] = useState<
    AllianceDataType[] | never[]
  >([]);
  const [UpdateBlind, OrderChange, Delete, setDelete] = UseCommonCard({
    data: AllianceData,
  });
  const NavFixContent = useCallback(
    (data: AllianceDataType) => {
      navigate("/alliance/fix", { state: data });
    },
    [navigate]
  );

  /** data 불러오기 임시 */
  const GetAlliance = useCallback(() => {
    officeApi
      .get("/web/cstm/prtn")
      .then(({ data: { sts_fg, succ_obj } }) => {
        if (sts_fg) {
          setAllianceData(succ_obj);
        }
      })
      .catch((err) => {
        console.log(err);
        alert(err.msg);
      });
  }, []);
  /** 삭제 함수 */
  const DeleteCard = useCallback(
    (data: AllianceDataType) => {
      const { prtn_id } = data;
      officeApi.delete(`/cstm/prtn/${prtn_id}`).then(({ data: { sts_fg } }) => {
        if (sts_fg) {
          GetAlliance();
        }
      });
    },
    [GetAlliance]
  );

  useLayoutEffect(() => {
    GetAlliance();
    return () => {};
  }, [GetAlliance]);

  return (
    <main className="alliance-page">
      <div className="wrapper">
        <div className="title">
          <div className="left">
            <p>팀플러 제휴 관리</p>
          </div>
          <div className="right">
            <Link to="/alliance/new" className="insert-alliance">
              제휴 등록
            </Link>
          </div>
        </div>
        <div className="sub">
          <div className="menu">
            <div className="name">제휴사명</div>
            <div className="content">제휴내용</div>
            <div className="blind">노출여부</div>
            <div className="order">순서 조정</div>
            <div className="delete">삭제하기</div>
          </div>
        </div>
        <div className="alliance-list">
          {AllianceData.length == 0 ? <Emty /> : null}
          {AllianceData.map((item, index) => {
            return (
              <AllianceCard
                key={index}
                data={item}
                setDelete={setDelete}
                Delete={Delete}
                index={index}
                UpdateBlind={UpdateBlind}
                OrderChange={OrderChange}
                DeleteCard={DeleteCard}
                NavFixContent={NavFixContent}
              />
            );
          })}
        </div>
      </div>
    </main>
  );
}

export default Alliance;
